module.exports = __webpack_public_path__ + "static/img/denali.d4d5840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/denali.jpg
// module id = sSYw
// module chunks = 1